import request from "@/utils/request";
import { IEviDict } from "../model/evidict";

// 实体
export const defaultEviDictData: IEviDict = {
  id: 0,
  type: 0,
  businessType: 0,
  pid: "",
  key: "",
  description: "",
  createTime: null,
  creatorId: "",
  sort: 0,
  updateTime: null,
  updateId: "",
  creatorName: "",
  updateName: "",
  pidName: ""
};

export const getEviDict = (id: any) => {
  request({
    url: "/EviDict/Get",
    method: "post",
    params: { id: id }
  });
};

export const addEviDict = (data: any) =>
  request({
    url: "/EviDict/Add",
    method: "post",
    data
  });

export const updateEviDict = (data: any) =>
  request({
    url: "/EviDict/Update",
    method: "post",
    data
  });

export const deleteEviDict = (id: any) =>
  request({
    url: "/EviDict/Delete",
    method: "post",
    params: { id: id }
  });

export const getEviDictPageList = (data: any) =>
  request({
    url: "/EviDict/GetPageListAsync",
    method: "post",
    data
  });

export const getCurrectDictArr = (pid: any, type: any) =>
  request({
    url: "/EviDict/GetCurrectDictArr",
    method: "post",
    params: { pid: pid, type: type }
  });

export const getBehaviorJsonInfo = (behaviorId: any) =>
  request({
    url: "/EviDict/GetBehaviorJsonInfo",
    method: "post",
    params: { behaviorId: behaviorId }
  });
